import { VStack } from "@/components/ui/vstack";
import { Text } from "@/components/ui/text";
import { Pressable } from "@/components/ui/pressable";
import { HStack } from "@/components/ui/hstack";
import React from 'react'
import i18n from "i18n-js";
import IssueIntensity from "../../algorithms_and_functions/validation/IssueIntensity";
import { IconMC } from '@/components/media/IconsV2';

export default function HighLightIssueButton({ issue, index, fitView }) {

    return (
        <Pressable onPress={() => fitView({ nodes: issue.getAffectedNodesIds() })} className="p-1 hover:bg-primary-100">
            <HStack space='sm'>
                <IconMC className={issue.intensity === IssueIntensity.Error ? 'text-error-600' : 'text-ina-yellow'} name='target' />
                <VStack space='xs' className="max-w-[270px]">
                    <Text bold className="text-black max-w-[220px]">#{index + 1} {i18n.t('global.' + issue.intensity)}: {i18n.t('studio.issue.' + issue.type)}</Text>
                    <Text className="text-black max-w-[220px]">{i18n.t('studio.issue.' + issue.type + 'Text')}</Text>
                </VStack>
            </HStack>
        </Pressable>
    );
}
